import { render, staticRenderFns } from "./CourseItemContent.vue?vue&type=template&id=185cc2fc&scoped=true&"
import script from "./CourseItemContent.vue?vue&type=script&lang=ts&"
export * from "./CourseItemContent.vue?vue&type=script&lang=ts&"
import style0 from "./CourseItemContent.vue?vue&type=style&index=0&id=185cc2fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185cc2fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('185cc2fc', component.options)
    } else {
      api.reload('185cc2fc', component.options)
    }
    module.hot.accept("./CourseItemContent.vue?vue&type=template&id=185cc2fc&scoped=true&", function () {
      api.rerender('185cc2fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/learningPaths/CourseItemContent.vue"
export default component.exports